import ApiServices from "./ApiServices";
import gql from "graphql-tag";

export default class AccountService extends ApiServices {
  constructor(credential = 'include') {
    super('/api/v1/account/', credential);
  }

  async getUserMetas(id) {
    return await this.apolloClass.query({
      query: gql`
          query user($id: Int!) {
            user(id: $id) {
              userMetas {
                account_field {
                  id
                  field
                }
                account_field_value {
                  id
                  value
                }
              }
            }
          }
        `,
      variables: {
        id,
      }
    });
  }

  async getAuthenticatedUser() {
    return await this.apolloClass.query({
      query: gql`{
        get_authenticated_user{
          id
          name
          token
          uid
        }
      }
      `
    });
  }

  async getConsentimento(id){
    return await this.apolloClass.query({
      query: gql`
        query getConsentiuCompromisso($id: Int!) {
          getConsentiuCompromisso(id: $id)
        }
      `,
      variables: {
        id
      }
    });
  }

  async getSegmentationsItemsByToken(token, module_name) {
    return await this.apolloClass.query({
      query: gql`
          query get_segmentations_items_by_token($token: String!, $module_name: String!) {
            get_segmentations_items_by_token(token: $token, module_name: $module_name ) {
              segmentations {
                id,
                item_id,
                course_title
              }
            }
          }
        `,
      variables: {
        token,
        module_name
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/services/AccountService.js